import ErrorScreen, { Error404 as _Error404 } from "./ErrorScreen.jsx";
export default ErrorScreen;
export const Error404 = _Error404;